
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface TemplatePreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  template: string;
  referralLink: string;
}

const TemplatePreviewDialog: React.FC<TemplatePreviewDialogProps> = ({
  isOpen,
  onClose,
  template,
  referralLink,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Template Preview</DialogTitle>
          <DialogDescription>
            This is how your referral message will appear to recipients
          </DialogDescription>
        </DialogHeader>
        
        <div className="bg-muted p-4 rounded-md">
          <div className="text-sm space-y-4">
            {template.replace('{referralLink}', referralLink)}
          </div>
        </div>
        
        <DialogFooter>
          <Button onClick={onClose}>
            Close Preview
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TemplatePreviewDialog;
